import React from 'react';

const pukukopit = () => {
  return (
    <div></div>
  );
};
export default pukukopit;
